import { cn } from '@Utils/cn';
import type { AiSuggestion } from '@Types/soul';

export function SuggestionPills({
  suggestions,
  onPick,
  className,
}: {
  suggestions: AiSuggestion[];
  onPick: (prompt: string) => void;
  className?: string;
}) {
  if (!suggestions.length) return null;
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {suggestions.slice(0, 4).map((s, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onPick(s.prompt)}
          title={s.prompt}
          className="rounded-full border border-zinc-200 bg-white px-3 py-1.5 text-xs text-zinc-600 transition-colors hover:border-zinc-300 hover:bg-zinc-50"
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}

// Placeholder shown while suggestions load. Reserves the same row height as the
// real pills so the layout doesn't jump, with a low-key staggered pulse.
export function SuggestionPillsSkeleton({ className }: { className?: string }) {
  const widths = ['w-28', 'w-36', 'w-24', 'w-32'];
  return (
    <div className={cn('flex flex-wrap gap-2', className)} aria-hidden>
      {widths.map((w, i) => (
        <div
          key={i}
          className={cn('h-7 animate-pulse rounded-full bg-zinc-100', w)}
          style={{ animationDelay: `${i * 120}ms` }}
        />
      ))}
    </div>
  );
}
